import request from "@/http"
import { IInsightData } from "./interface"
import { API } from "../constants/config"
import moment from "moment"
const API_LOCAL = window.location.origin + window.location.pathname
/**
 *  获取tag列表
 */
export async function getTags(): Promise<any> {
  try {
    let list: any[] = await request.get(API_LOCAL + "/data/tags.json")
    list.forEach((item) => {
      let total = 0
      item.tags = item.tags.sort((a, b) => b.count - a.count)
      if (["104004", "106013"].includes(item.id)) {
        item.tags = item.tags.slice(1)
      }
      item.tags.forEach((tag) => {
        total += tag.count
      })
      item.total = total
      item.tags.forEach((tag) => {
        tag.value = Math.round((tag.count * 100) / total) / 100
      })
    })
    return list
  } catch (error) {
    console.log("error", error)
  }
}

/**
 * 预览报告
 *
 * @export
 * @param {string} id
 * @returns {Promise<IInsightData>}
 */
export async function previewReport(): Promise<IInsightData> {
  try {
    const result: IInsightData = await request.get(
      API_LOCAL + "/data/graph.json"
    )
    return result
  } catch (error) {
    console.log(`WAYZ: previewReport -> error`, error)
  }
}
export const confImgLabel = {
  大厅: {
    icon: require("../assets/photo/seed.jpeg"),
    icon_c: require("../assets/photo/seed_c.png"),
    coord: [121.60874022056222, 31.184878523967155],
    icon_name: "seed",
  },
  AI医疗: {
    icon: require("../assets/photo/medical.jpeg"),
    icon_c: require("../assets/photo/medical_c.png"),
    coord: [121.60856101461303, 31.1844052718927],
    icon_name: "medical",
  },
  AI校园: {
    icon: require("../assets/photo/school.jpeg"),
    icon_c: require("../assets/photo/school_c.png"),
    coord: [121.60843641445054, 31.184471927016072],
    icon_name: "school",
  },
  AI指挥中心: {
    icon: require("../assets/photo/smart.jpeg"),
    icon_c: require("../assets/photo/smart_c.png"),
    coord: [121.60888194392038, 31.184339862289977],
    icon_name: "smart",
  },
  AI产品展示: {
    icon: require("../assets/photo/product.jpeg"),
    icon_c: require("../assets/photo/product_c.png"),
    coord: [121.60873142682986, 31.184350208784803],
    icon_name: "product",
  },
  AI制造: {
    icon: require("../assets/photo/manufact.png"),
    icon_c: require("../assets/photo/manufact_c.png"),
    coord: [121.60901022056222, 31.184768523967155],
    icon_name: "manufact",
  },
  AI家居: {
    icon: require("../assets/photo/ehome.png"),
    icon_c: require("../assets/photo/ehome_c.png"),
    coord: [121.60833641445054, 31.184571927016072],
    icon_name: "ehome",
  },
}
export async function getFlooGeo(): Promise<any> {
  try {
    let geo: any = await request.get(API_LOCAL + "/data/ai_F1.geojson")
    geo.features.forEach((feature, i) => {
      let { properties: prop, geometry } = feature
      prop.name = prop.FT_NAME_DP
      if (!prop.category) {
        return
      }
      if (!prop.center) {
        let c = [0, 0]
        let len = 0
        geometry.coordinates[0][0].forEach(([lng, lat]) => {
          len++
          c[0] += lng
          c[1] += lat
        })
        // console.log("showLabel -> c", c)
        c[0] /= len
        c[1] /= len
        prop.center = c
      }
      if (confImgLabel[prop.name]) {
        confImgLabel[prop.name].from = prop.center
      }
    })
    return { geo, confImgLabel }
  } catch (error) {
    console.log("error", error)
  }
}

export async function getAreaGeo(): Promise<any> {
  try {
    let geo: any = await request.get(API_LOCAL + "/data/ai_island.json")
    return geo
  } catch (error) {
    console.log("error", error)
  }
}

export async function heat(): Promise<any> {
  try {
    return await request.get(API + "/location/footfall/v1/heatmaps/realtime", {
      params: {
        place: "ai_island",
        grid_level: 12,
        access_key: "4isZqeXCc2HVbALuLxxbEHjYG3dH4wcK",
      },
    })
  } catch (error) {
    console.log("error", error)
  }
}
export async function historyHeat(): Promise<any> {
  try {
    return await request.get(API + "/location/footfall/v1/heatmaps", {
      params: {
        place: "ai_island",
        grid_level: 11,
        access_key: "4isZqeXCc2HVbALuLxxbEHjYG3dH4wcK",
        start_time: "2020-07-21 00:00:00",
        end_time: "2020-07-23 23:00:00",
      },
    })
  } catch (error) {
    console.log("error", error)
  }
}
function rand(min, max) {
  let n = Math.random() * (max - min) + min
  if (n < 10) {
    return "0" + n
  }
  return "" + n
}
let location = window.location
export async function areaLv(): Promise<any> {
  try {
    let res: [][] = await request.get(location.origin + location.pathname + "/data/lv.json")
    let list: any = res
    list.forEach((a, i) => {
      let time = `${rand(0, 23)}:${rand(0, 59)}:${rand(0, 59)}`
      a.push(moment(time, "HH:mm:ss").unix(), time, i)
    })
    return list
  } catch (error) {
    console.log("error", error)
  }
  // try {
  //   let res: string = await request.get(
  //     "https://s3.cn-northwest-1.amazonaws.com.cn/lbi-ka/ai_island/hour"
  //   )
  //   let list = []
  //   res.split("\n").forEach((l, i) => {
  //     if (l && l.includes(",")) {
  //       let [lon, lat, time] = l.split(",")
  //       list.push([
  //         parseFloat(lon),
  //         parseFloat(lat),
  //         moment(time, "HH:mm:ss").unix(),
  //         time,
  //         i,
  //       ])
  //     }
  //   })
  //   return list
  // } catch (error) {
  //   console.log("error", error)
  // }
}
// https://s3.cn-northwest-1.amazonaws.com.cn/lbi-ka/dashboard-heat/14
const files = [
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-15", // 六 1
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-16", // 日 2
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-17", // 一 3
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-18", // 二 4
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-19", // 三 5
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-20", // 四 6
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-21", // 五 7
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-22", // 六 8
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-23", // 日 9
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-24", // 一 10
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-25", // 二 11
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-26", // 三 12
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-27", // 四 13
  "https://s3.cn-northwest-1.amazonaws.com.cn/wz-dmp/dashboard-heat/2020-08-28", // 五 14
]
export async function areaHeat(week, day): Promise<any> {
  if (day >= 6) {
    day -= 5
  } else {
    day += 2
  }
  let fileIdx = week * 7 + day
  try {
    let res: string = await request.get(
      "https://s3.cn-northwest-1.amazonaws.com.cn/lbi-ka/dashboard-heat/" +
        fileIdx
    )
    let list = []
    res.split("\n").forEach((l) => {
      if (l && l.includes(",")) {
        list.push(l.split(",").map(parseFloat))
      }
    })
    return list
  } catch (error) {
    console.log("error", error)
  }
}
